export const deploymentsSuggestionsDictionary = {
  name: "name",
  slug: "ID",
} as { [key: string]: string };

export const sortItemOrder = ["status", "version"];
